import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="evenodd" clipRule="evenodd" fill="#000"><path d="M5.496 4.8L1.382 12l4.114 7.2H21.6V4.8H5.496zM4.8 20.4L0 12l4.8-8.4h18v16.8h-18z" /><path d="M12.914 12L9.6 8.686l.886-.886 3.314 3.314L17.114 7.8l.886.886L14.686 12 18 15.315l-.886.885-3.314-3.314-3.314 3.314-.886-.885L12.914 12z" /></g></svg>;